import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-card-hover">
      <h3 className="text-lg font-heading font-bold text-foreground mb-4 flex items-center space-x-2">
        <Icon name="Filter" size={20} color="var(--color-primary)" />
        <span>Kategori</span>
      </h3>
      <div className="space-y-2">
        {categories?.map((category) => (
          <button
            key={category?.id}
            onClick={() => onCategoryChange(category?.id)}
            className={`w-full flex items-center justify-between p-3 rounded-lg transition-all duration-300 ${
              activeCategory === category?.id
                ? 'bg-primary text-primary-foreground shadow-honda-subtle'
                : 'bg-muted text-foreground hover:bg-primary/10 hover:text-primary'
            }`}
          >
            <div className="flex items-center space-x-3">
              <Icon 
                name={category?.icon} 
                size={20} 
                color={activeCategory === category?.id ? 'white' : 'var(--color-foreground)'} 
              />
              <span className="font-heading font-semibold text-sm">{category?.name}</span>
            </div>
            <span className={`text-xs font-bold px-2 py-1 rounded-full ${
              activeCategory === category?.id
                ? 'bg-primary-foreground text-primary'
                : 'bg-background text-muted-foreground'
            }`}>
              {category?.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;